export default __webpack_public_path__ + "static/media/pageNotFound404.6aeace81.png";